import callAPiBase from './base';

const ratingApi = {
  listChart: ({
    startDate,
    endDate,
    data,
  }: {
    startDate: number;
    endDate: number;
    data: object;
  }) =>
    callAPiBase({
      endpoint: `/api/reports/attendants/rating?startDate=${startDate}&endDate=${endDate}`,
      method: 'POST',
      useToken: true,
      data,
    }),

  list: ({
    params: {
      startDate,
      endDate,
      attendantId,
      ratingId,
      createdAt,
      scanForward,
      limit,
    },
  }: {
    params: {
      startDate: number;
      endDate: number;
      attendantId: string;
      ratingId: string;
      createdAt: number;
      scanForward: string;
      limit: number;
    };
  }) =>
    callAPiBase({
      endpoint: `/api/ratings?startDate=${startDate}&endDate=${endDate}&attendantId=${attendantId}&ratingId=${ratingId}&limit=${limit}&createdAt=${createdAt}&scanForward=${scanForward}`,
      method: 'GET',
      useToken: true,
    }),
};

export { ratingApi };
export default ratingApi;
